// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n.footer-text {\n  text-align: center;\n  color: #868e96 !important;\n}\n\n.dark-mode {\n  color: #ffffff !important;\n}\n\n.footer-div {\n  margin-top: 2rem;\n  padding-bottom: 1rem;\n}", ""]);
// Exports
module.exports = exports;
